// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#tokenchartdiv[data-v-2a88a0d2] {\n  width: 100%;\n  height: 100%;\n  overflow: visible;\n}\n@media screen and (max-width: 1150px) {\n#tokenchartdiv[data-v-2a88a0d2] {\n    height: 200px;\n    align-self: center;\n    margin-right: 0;\n    margin-left: 0;\n}\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
